import { render, staticRenderFns } from "./DeveloperPortal.vue?vue&type=template&id=244039e7&"
import script from "./DeveloperPortal.vue?vue&type=script&lang=js&"
export * from "./DeveloperPortal.vue?vue&type=script&lang=js&"
import style0 from "./DeveloperPortal.vue?vue&type=style&index=0&id=244039e7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports